import Video from '@/data/Video';
import IVideoSort from '@/utils/IVideoSort';

export default class VideoSortByDate implements IVideoSort {

  public getComparator(): (video1: Video, video2: Video) => number {

    return (video1: Video, video2: Video) => {
      
      // zero values are regarded as non existing values.
      // larger values before lower values

      let v1Value = video1.publicationDate;
      let v2Value = video2.publicationDate;
      
      if(!video1.publicationDate) {
        v1Value = video1.createdDate;
      }
      if(!video2.publicationDate) {
        v2Value = video2.createdDate;
      }

      if(v1Value === undefined) v1Value = 0;
      if(v2Value === undefined) v2Value = 0;

      return v2Value - v1Value;
    };
  }

  public sort(videos: Array<Video>, calcOwnPrio?: boolean): Array<Video> {
    if(!videos) return videos;
    return videos.sort(this.getComparator());
  }
}